var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Actor_ } from '../../../../components/actor/Actor_';
let AbfragerAssociateAssociationButton = class AbfragerAssociateAssociationButton extends React.PureComponent {
    render() {
        const { association, className } = this.props;
        return (React.createElement(Actor_, { actor: association, structureTemplate: React.createElement("div", { className: className || 'btn btn-default btn-lg', style: { lineHeight: 1.1, borderRadius: 10 } },
                React.createElement("div", { "data-aspect": "inner" })) }));
    }
};
AbfragerAssociateAssociationButton = __decorate([
    observer
], AbfragerAssociateAssociationButton);
export { AbfragerAssociateAssociationButton };
